import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {
  GetIntervenantListingGQL,
  GetOuvrageByIdGQL,
  UpdateOuvrageGQL,
  UpdateOuvrageMutationVariables
} from "../../../../graphql/generated";
import {map} from "rxjs";
import {ClassdefinitionService} from "../../services/classdefinition.service";
import {Classdefinition} from "../../model/classdefinition";
import {OuvrageService} from "../../services/ouvrage.service";
import {ConfirmationService, MenuItem} from "primeng/api";
import {PagesAtterissageComponent} from "../../ressources_numeriques/pages-atterissage/pages-atterissage.component";
import {RessourcesNumeriquesComponent} from "../../ressources_numeriques/ressources-numeriques/ressources-numeriques.component";
import {UserService} from "../../services/user.service";
import {json} from "stream/consumers";
import {isArray} from "@apollo/client/utilities";

@Component({
  selector: 'app-resume-ouvrage',
  templateUrl: './resume-ouvrage.component.html',
  styleUrls: ['./resume-ouvrage.component.scss']
})
export class ResumeOuvrageComponent implements OnInit {

  @Input() ouvrageId: number;
  @Output() onDataChange: EventEmitter<any> = new EventEmitter();
  @Output() onStatutChange: EventEmitter<any> = new EventEmitter();

  ouvrage: any = {}
  classDef: Classdefinition;
  successMessage: string = '';
  errors: string[] = [];
  steps: MenuItem[];
  activeStep: number;
  showResume: boolean = false;
  intervenant: string;

  constructor(
    private service: GetOuvrageByIdGQL,
    private classDefinition: ClassdefinitionService,
    private ouvrageService: OuvrageService,
    private updateOuvrageService: UpdateOuvrageGQL,
    private intervenantService: GetIntervenantListingGQL,
    public userService: UserService,
    private confirmationService: ConfirmationService
  ) {
  }

  ngOnInit() {
    var filterOuvrageId: string = "{\"ouvrage__id\": " + this.ouvrageId + "}"

    this.classDefinition.load().then(() => {
      this.classDef = this.classDefinition.getByName('BaseArticle')

      this.steps = [
        {label: 'Brouillon'},
        {label: 'Alimentation des ressources', styleClass: 'alim_ressource'},
        {label: 'Finalisé'},
      ];

      this.loadOuvrage()
    });
  }

  loadOuvrage() {
    this.service.watch({id: this.ouvrageId}).valueChanges.pipe(
      map(result => result.data.getOuvrage)
    ).subscribe({
        next: value => {
          this.ouvrage = value
          this.activeStep = Number(value?.statut)
          const intervenantCode = this.ouvrage.BaseArticle.AssistantEdito;
          this.intervenantService.fetch({filter: JSON.stringify({code:intervenantCode})}).subscribe({
            next: value => {
              if(value.data.getIntervenantListing?.edges  && isArray(value.data.getIntervenantListing?.edges)){
                 if(value.data.getIntervenantListing?.edges[0]?.node) {
                   this.intervenant = value.data.getIntervenantListing?.edges[0]?.node?.display_name?? '';
                 }
              }
            }
          });
        }
      }
    )
  }

  getLabelValues(
    values,
    field
  ) {

    var valuesArrayFormatted: Array<string> = []
    var self = this

    if (typeof this.classDef !== 'undefined' && values !== null && field !== null) {
      values.forEach(function (
        value,
        key
      ) {
        var label = self.classDef.fdef[field]['optionsLabel'][value]
        valuesArrayFormatted.push(label)
      });

      if(field === 'Matieres' || field === 'Classe') {
        valuesArrayFormatted = valuesArrayFormatted.filter(value => value !== null && value !== undefined && value !== '');
      }

      return valuesArrayFormatted.join(',')
    }

    return null
  }

  updateOuvrage(event: any,type: string, inputType: string = 'text') {
    let value = event.target.value
    if(inputType === 'checkbox') {
       value = event.target.checked ? 'true' : 'false';
    }
    this.onDataChange.emit({type: type, value: value})
  }


  validateOuvrage() {
    var input = {}
    var statut = '0'
    if (this.ouvrage.statut === '0') {
      statut = '1'
    } else if (this.ouvrage.statut === '1') {
      statut = '2'
    }
    input['statut'] = statut

    const variables: UpdateOuvrageMutationVariables = {
      id: this.ouvrageId,
      input: input
    }

    this.updateOuvrageService.mutate(variables).subscribe({
      next: value => {
        this.loadOuvrage()
        this.onStatutChange.emit()
      },
      error: err => {
      }
    });
  }

  onValidateButtonClick() {
    if (this.ouvrage.statut === '2' && this.userService.isSuperCem()) {
      this.confirmationService.confirm({
        message: 'Voulez-vous vraiment déverrouiller ce projet ? Il repassera à l\'étape "Brouillon" et le code projet ainsi que "Ouvrage réforme" redeviendront modifiables.',
        header: 'Déverrouiller le projet',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.unlockOuvrage()
        }
      });
      return;
    }

    this.validateOuvrage()
  }

  unlockOuvrage() {
    const variables: UpdateOuvrageMutationVariables = {
      id: this.ouvrageId,
      input: {statut: '0'}
    }

    this.updateOuvrageService.mutate(variables).subscribe({
      next: value => {
        this.loadOuvrage()
        this.onStatutChange.emit()
      },
      error: err => {
      }
    });
  }


  getOptionsLabel(
    field,
    value
  ) {
    if (typeof this.classDef !== 'undefined') {
      return this.classDef.fdef[field].optionsLabel[[value]]
    }

    return null
  }

  isButtonEnabled() {
    if (this.ouvrage.statut === '0') {
      return true;
    }
    if (this.ouvrage.statut === '1') {
      return true;
    }

    if (this.ouvrage.statut === '2') {
      return this.userService.isSuperCem();
    }

    return false;

  }

  displayResume(event) {
    this.showResume = !this.showResume
    event.preventDefault()
  }
}
